"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.create.success': 'Slot data created successfully',
    'slotData.create.error': 'Failed to create slot data',
};
